import { Money, MoneyCurrency } from '@booking-core/domain/value_objects/money.js';
import type {
  PricingInput,
  PricingStrategy,
} from '../pricing-strategy.js';

export interface HourlyPerSeatParams {
  /** TWD per seat per hour. */
  readonly amountPerSeatPerHour: number;
  /** Fixed seat count for this zone (e.g. 4-seat VR booth). */
  readonly seatCount: number;
}

/**
 * 每座位每小時。Total = amount × (min/60) × seatCount, Math.round 最終。
 * partySize is intentionally ignored — fixed-seat pricing.
 */
export class HourlyPerSeatStrategy implements PricingStrategy {
  constructor(private readonly params: HourlyPerSeatParams) {
    if (params.seatCount <= 0) {
      throw new Error('HourlyPerSeatStrategy: seatCount must be > 0');
    }
  }

  quote(input: PricingInput): Money {
    void input.partySize;
    const raw =
      this.params.amountPerSeatPerHour *
      (input.billableDurationMinutes / 60) *
      this.params.seatCount;
    return Money.of({ amount: Math.round(raw), currency: MoneyCurrency.TWD });
  }
}
